import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, unref as _unref, Fragment as _Fragment, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9a96acfa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "slide-design-panel" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "背景填充", -1))
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"10px"} }, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "background-image-wrapper"
}
const _hoisted_6 = { class: "background-image" }
const _hoisted_7 = {
  key: 1,
  class: "background-gradient-wrapper"
}
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"40%"} }, "起点颜色：", -1))
const _hoisted_10 = { class: "row" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"40%"} }, "终点颜色：", -1))
const _hoisted_12 = {
  key: 0,
  class: "row"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"40%"} }, "渐变角度：", -1))
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"40%"} }, "画布尺寸：", -1))
const _hoisted_17 = { class: "title" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "全局主题", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "更多", -1))
const _hoisted_20 = { class: "row" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"40%"} }, "字体：", -1))
const _hoisted_22 = { class: "row" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"40%"} }, "字体颜色：", -1))
const _hoisted_24 = { class: "row" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"40%"} }, "背景颜色：", -1))
const _hoisted_26 = { class: "row" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"40%"} }, "主题色：", -1))
const _hoisted_28 = { class: "row" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"40%"} }, "边框样式：", -1))
const _hoisted_30 = { class: "row" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"40%"} }, "边框颜色：", -1))
const _hoisted_32 = { class: "row" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"40%"} }, "边框粗细：", -1))
const _hoisted_34 = {
  class: "row",
  style: {"height":"30px"}
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"40%"} }, "水平阴影：", -1))
const _hoisted_36 = {
  class: "row",
  style: {"height":"30px"}
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"40%"} }, "垂直阴影：", -1))
const _hoisted_38 = {
  class: "row",
  style: {"height":"30px"}
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"40%"} }, "模糊距离：", -1))
const _hoisted_40 = { class: "row" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"40%"} }, "阴影颜色：", -1))
const _hoisted_42 = { class: "row" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "预置主题", -1))
const _hoisted_44 = { class: "theme-list" }
const _hoisted_45 = { class: "theme-item-content" }
const _hoisted_46 = { class: "colors" }
const _hoisted_47 = { class: "btns" }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = ["onClick"]

import { computed, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import type { SlideBackground, SlideTheme } from '@/types/slides'
import { PRESET_THEMES } from '@/configs/theme'
import { WEB_FONTS } from '@/configs/font'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'
import useSlideTheme from '@/hooks/useSlideTheme'
import { getImageDataURL } from '@/utils/image'

import ColorButton from './common/ColorButton.vue'
import FileInput from '@/components/FileInput.vue'
import ColorPicker from '@/components/ColorPicker/index.vue'
import Divider from '@/components/Divider.vue'
import Slider from '@/components/Slider.vue'
import Button from '@/components/Button.vue'
import Select from '@/components/Select.vue'
import Popover from '@/components/Popover.vue'
import NumberInput from '@/components/NumberInput.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SlideDesignPanel',
  setup(__props) {

const slidesStore = useSlidesStore()
const { availableFonts } = storeToRefs(useMainStore())
const { slides, currentSlide, viewportRatio, theme } = storeToRefs(slidesStore)

const moreThemeConfigsVisible = ref(false)

const background = computed(() => {
  if (!currentSlide.value.background) {
    return {
      type: 'solid',
      value: '#fff',
    } as SlideBackground
  }
  return currentSlide.value.background
})

const { addHistorySnapshot } = useHistorySnapshot()
const {
  applyPresetThemeToSingleSlide,
  applyPresetThemeToAllSlides,
  applyThemeToAllSlides,
} = useSlideTheme()

// 设置背景模式：纯色、图片、渐变色
const updateBackgroundType = (type: 'solid' | 'image' | 'gradient') => {
  if (type === 'solid') {
    const newBackground: SlideBackground = {
      ...background.value,
      type: 'solid',
      color: background.value.color || '#fff',
    }
    slidesStore.updateSlide({ background: newBackground })
  }
  else if (type === 'image') {
    const newBackground: SlideBackground = {
      ...background.value,
      type: 'image',
      image: background.value.image || '',
      imageSize: background.value.imageSize || 'cover',
    }
    slidesStore.updateSlide({ background: newBackground })
  }
  else {
    const newBackground: SlideBackground = {
      ...background.value,
      type: 'gradient',
      gradientType: background.value.gradientType || 'linear',
      gradientColor: background.value.gradientColor || ['#fff', '#fff'],
      gradientRotate: background.value.gradientRotate || 0,
    }
    slidesStore.updateSlide({ background: newBackground })
  }
  addHistorySnapshot()
}

// 设置背景图片
const updateBackground = (props: Partial<SlideBackground>) => {
  slidesStore.updateSlide({ background: { ...background.value, ...props } })
  addHistorySnapshot()
}

// 上传背景图片
const uploadBackgroundImage = (files: FileList) => {
  const imageFile = files[0]
  if (!imageFile) return
  getImageDataURL(imageFile).then(dataURL => updateBackground({ image: dataURL }))
}

// 应用当前页背景到全部页面
const applyBackgroundAllSlide = () => {
  const newSlides = slides.value.map(slide => {
    return {
      ...slide,
      background: currentSlide.value.background,
    }
  })
  slidesStore.setSlides(newSlides)
  addHistorySnapshot()
}

// 设置主题
const updateTheme = (themeProps: Partial<SlideTheme>) => {
  slidesStore.setTheme(themeProps)
}

// 设置画布尺寸（宽高比例）
const updateViewportRatio = (value: number) => {
  slidesStore.setViewportRatio(value)
}

return (_ctx: any,_cache: any) => {
  const _component_IconPlus = _resolveComponent("IconPlus")!
  const _component_IconDown = _resolveComponent("IconDown")!
  const _component_IconRight = _resolveComponent("IconRight")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(Select, {
        style: {"flex":"1"},
        value: background.value.type,
        "onUpdate:value": _cache[0] || (_cache[0] = value => updateBackgroundType(value as 'gradient' | 'image' | 'solid')),
        options: [
          { label: '纯色填充', value: 'solid' },
          { label: '图片填充', value: 'image' },
          { label: '渐变填充', value: 'gradient' },
        ]
      }, null, 8, ["value"]),
      _hoisted_4,
      (background.value.type === 'solid')
        ? (_openBlock(), _createBlock(Popover, {
            key: 0,
            trigger: "click",
            style: {"flex":"1"}
          }, {
            content: _withCtx(() => [
              _createVNode(ColorPicker, {
                modelValue: background.value.color,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = color => updateBackground({ color }))
              }, null, 8, ["modelValue"])
            ]),
            default: _withCtx(() => [
              _createVNode(ColorButton, {
                color: background.value.color || '#fff'
              }, null, 8, ["color"])
            ]),
            _: 1
          }))
        : (background.value.type === 'image')
          ? (_openBlock(), _createBlock(Select, {
              key: 1,
              style: {"flex":"1"},
              value: background.value.imageSize || 'cover',
              "onUpdate:value": _cache[2] || (_cache[2] = value => updateBackground({ imageSize: value as 'repeat' | 'cover' | 'contain' })),
              options: [
          { label: '缩放', value: 'contain' },
          { label: '拼贴', value: 'repeat' },
          { label: '缩放铺满', value: 'cover' },
        ]
            }, null, 8, ["value"]))
          : (_openBlock(), _createBlock(Select, {
              key: 2,
              style: {"flex":"1"},
              value: background.value.gradientType || '',
              "onUpdate:value": _cache[3] || (_cache[3] = value => updateBackground({ gradientType: value as 'linear' | 'radial' })),
              options: [
          { label: '线性渐变', value: 'linear' },
          { label: '径向渐变', value: 'radial' },
        ]
            }, null, 8, ["value"]))
    ]),
    (background.value.type === 'image')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(FileInput, {
            onChange: _cache[4] || (_cache[4] = files => uploadBackgroundImage(files))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  class: "content",
                  style: _normalizeStyle({ backgroundImage: `url(${background.value.image})` })
                }, [
                  _createVNode(_component_IconPlus)
                ], 4)
              ])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (background.value.type === 'gradient')
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(Popover, {
              trigger: "click",
              style: {"width":"60%"}
            }, {
              content: _withCtx(() => [
                _createVNode(ColorPicker, {
                  modelValue: background.value.gradientColor![0],
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = value => updateBackground({ gradientColor: [value, background.value.gradientColor![1]] }))
                }, null, 8, ["modelValue"])
              ]),
              default: _withCtx(() => [
                _createVNode(ColorButton, {
                  color: background.value.gradientColor![0]
                }, null, 8, ["color"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(Popover, {
              trigger: "click",
              style: {"width":"60%"}
            }, {
              content: _withCtx(() => [
                _createVNode(ColorPicker, {
                  modelValue: background.value.gradientColor![1],
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = value => updateBackground({ gradientColor: [background.value.gradientColor![0], value] }))
                }, null, 8, ["modelValue"])
              ]),
              default: _withCtx(() => [
                _createVNode(ColorButton, {
                  color: background.value.gradientColor![1]
                }, null, 8, ["color"])
              ]),
              _: 1
            })
          ]),
          (background.value.gradientType === 'linear')
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _hoisted_13,
                _createVNode(Slider, {
                  min: 0,
                  max: 360,
                  step: 15,
                  value: background.value.gradientRotate || 0,
                  "onUpdate:value": _cache[7] || (_cache[7] = value => updateBackground({ gradientRotate: value as number })),
                  style: {"width":"60%"}
                }, null, 8, ["value"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(Button, {
        style: {"flex":"1"},
        onClick: _cache[8] || (_cache[8] = ($event: any) => (applyBackgroundAllSlide()))
      }, {
        default: _withCtx(() => [
          _createTextVNode("应用背景到全部")
        ]),
        _: 1
      })
    ]),
    _createVNode(Divider),
    _createElementVNode("div", _hoisted_15, [
      _hoisted_16,
      _createVNode(Select, {
        style: {"width":"60%"},
        value: _unref(viewportRatio),
        "onUpdate:value": _cache[9] || (_cache[9] = value => updateViewportRatio(value as number)),
        options: [
          { label: '宽屏 16 : 9', value: 0.5625 },
          { label: '宽屏 16 : 10', value: 0.625 },
          { label: '标准 4 : 3', value: 0.75 },
          { label: '纸张 A3 / A4', value: 0.70710678 },
        ]
      }, null, 8, ["value"])
    ]),
    _createVNode(Divider),
    _createElementVNode("div", _hoisted_17, [
      _hoisted_18,
      _createElementVNode("span", {
        class: "more",
        onClick: _cache[10] || (_cache[10] = ($event: any) => (moreThemeConfigsVisible.value = !moreThemeConfigsVisible.value))
      }, [
        _hoisted_19,
        (moreThemeConfigsVisible.value)
          ? (_openBlock(), _createBlock(_component_IconDown, { key: 0 }))
          : (_openBlock(), _createBlock(_component_IconRight, { key: 1 }))
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _hoisted_21,
      _createVNode(Select, {
        style: {"width":"60%"},
        value: _unref(theme).fontName,
        "onUpdate:value": _cache[11] || (_cache[11] = value => updateTheme({ fontName: value as string })),
        options: [
          ..._unref(availableFonts),
          ..._unref(WEB_FONTS)
        ]
      }, null, 8, ["value", "options"])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _hoisted_23,
      _createVNode(Popover, {
        trigger: "click",
        style: {"width":"60%"}
      }, {
        content: _withCtx(() => [
          _createVNode(ColorPicker, {
            modelValue: _unref(theme).fontColor,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = value => updateTheme({ fontColor: value }))
          }, null, 8, ["modelValue"])
        ]),
        default: _withCtx(() => [
          _createVNode(ColorButton, {
            color: _unref(theme).fontColor
          }, null, 8, ["color"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_24, [
      _hoisted_25,
      _createVNode(Popover, {
        trigger: "click",
        style: {"width":"60%"}
      }, {
        content: _withCtx(() => [
          _createVNode(ColorPicker, {
            modelValue: _unref(theme).backgroundColor,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = value => updateTheme({ backgroundColor: value }))
          }, null, 8, ["modelValue"])
        ]),
        default: _withCtx(() => [
          _createVNode(ColorButton, {
            color: _unref(theme).backgroundColor
          }, null, 8, ["color"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_26, [
      _hoisted_27,
      _createVNode(Popover, {
        trigger: "click",
        style: {"width":"60%"}
      }, {
        content: _withCtx(() => [
          _createVNode(ColorPicker, {
            modelValue: _unref(theme).themeColor,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = value => updateTheme({ themeColor: value }))
          }, null, 8, ["modelValue"])
        ]),
        default: _withCtx(() => [
          _createVNode(ColorButton, {
            color: _unref(theme).themeColor
          }, null, 8, ["color"])
        ]),
        _: 1
      })
    ]),
    (moreThemeConfigsVisible.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createVNode(Select, {
              style: {"width":"60%"},
              value: _unref(theme).outline.style || '',
              "onUpdate:value": _cache[15] || (_cache[15] = value => updateTheme({ outline: { ..._unref(theme).outline, style: value as 'dashed' | 'solid' } })),
              options: [
            { label: '实线边框', value: 'solid' },
            { label: '虚线边框', value: 'dashed' },
          ]
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            _createVNode(Popover, {
              trigger: "click",
              style: {"width":"60%"}
            }, {
              content: _withCtx(() => [
                _createVNode(ColorPicker, {
                  modelValue: _unref(theme).outline.color,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = value => updateTheme({ outline: { ..._unref(theme).outline, color: value } }))
                }, null, 8, ["modelValue"])
              ]),
              default: _withCtx(() => [
                _createVNode(ColorButton, {
                  color: _unref(theme).outline.color || '#000'
                }, null, 8, ["color"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_32, [
            _hoisted_33,
            _createVNode(NumberInput, {
              value: _unref(theme).outline.width || 0,
              "onUpdate:value": _cache[17] || (_cache[17] = value => updateTheme({ outline: { ..._unref(theme).outline, width: value } })),
              style: {"width":"60%"}
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _hoisted_35,
            _createVNode(Slider, {
              style: {"width":"60%"},
              min: -10,
              max: 10,
              step: 1,
              value: _unref(theme).shadow.h,
              "onUpdate:value": _cache[18] || (_cache[18] = value => updateTheme({ shadow: { ..._unref(theme).shadow, h: value as number } }))
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _hoisted_37,
            _createVNode(Slider, {
              style: {"width":"60%"},
              min: -10,
              max: 10,
              step: 1,
              value: _unref(theme).shadow.v,
              "onUpdate:value": _cache[19] || (_cache[19] = value => updateTheme({ shadow: { ..._unref(theme).shadow, v: value as number } }))
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _hoisted_39,
            _createVNode(Slider, {
              style: {"width":"60%"},
              min: 1,
              max: 20,
              step: 1,
              value: _unref(theme).shadow.blur,
              "onUpdate:value": _cache[20] || (_cache[20] = value => updateTheme({ shadow: { ..._unref(theme).shadow, blur: value as number } }))
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_40, [
            _hoisted_41,
            _createVNode(Popover, {
              trigger: "click",
              style: {"width":"60%"}
            }, {
              content: _withCtx(() => [
                _createVNode(ColorPicker, {
                  modelValue: _unref(theme).shadow.color,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = value => updateTheme({ shadow: { ..._unref(theme).shadow, color: value } }))
                }, null, 8, ["modelValue"])
              ]),
              default: _withCtx(() => [
                _createVNode(ColorButton, {
                  color: _unref(theme).shadow.color
                }, null, 8, ["color"])
              ]),
              _: 1
            })
          ])
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_42, [
      _createVNode(Button, {
        style: {"flex":"1"},
        onClick: _cache[22] || (_cache[22] = ($event: any) => (_unref(applyThemeToAllSlides)(moreThemeConfigsVisible.value)))
      }, {
        default: _withCtx(() => [
          _createTextVNode("应用主题到全部")
        ]),
        _: 1
      })
    ]),
    _createVNode(Divider),
    _hoisted_43,
    _createElementVNode("div", _hoisted_44, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(PRESET_THEMES), (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "theme-item",
          key: index,
          style: _normalizeStyle({
          backgroundColor: item.background,
          fontFamily: item.fontname,
        })
        }, [
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", {
              class: "text",
              style: _normalizeStyle({ color: item.fontColor })
            }, "文字 Aa", 4),
            _createElementVNode("div", _hoisted_46, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.colors, (color, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "color-block",
                  key: index,
                  style: _normalizeStyle({ backgroundColor: color})
                }, null, 4))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", {
                class: "btn",
                onClick: ($event: any) => (_unref(applyPresetThemeToSingleSlide)(item))
              }, "应用", 8, _hoisted_48),
              _createElementVNode("div", {
                class: "btn",
                onClick: ($event: any) => (_unref(applyPresetThemeToAllSlides)(item))
              }, "应用全局", 8, _hoisted_49)
            ])
          ])
        ], 4))
      }), 128))
    ])
  ]))
}
}

})